import { Transform } from 'class-transformer';
import { IsEmail, IsNotEmpty, IsOptional, IsString, Matches, ValidateIf } from 'class-validator';
import { IsCap } from '../../validation/is-cap.decorator';
import { IsPartitaIva } from '../../validation/is-partita-iva.decorator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { PROVINCIA_REGEX } from '../../validation/provincia';

function uppercase({ value }: { value: unknown }): unknown {
  return typeof value === 'string' ? value.toUpperCase() : value;
}

/** A destination field was filled in, so the destination group (via/cap/citta) is required. */
function hasAnyDestinationField(o: UpdateCustomerDto): boolean {
  return !!(o.destinationVia || o.destinationCap || o.destinationCitta || o.destinationProvincia);
}

export class UpdateCustomerDto {
  @IsString()
  @IsNotEmpty()
  @IsOptional()
  name?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  @IsPartitaIva()
  vatNumber?: string | null;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  codiceFiscale?: string | null;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  addressVia?: string;

  @IsOptional()
  @IsCap()
  addressCap?: string;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  addressCitta?: string;

  @IsOptional()
  @Transform(uppercase)
  @Matches(PROVINCIA_REGEX, { message: 'Provincia non valida' })
  addressProvincia?: string;

  @ValidateIf(hasAnyDestinationField)
  @IsString()
  @IsNotEmpty()
  destinationVia?: string | null;

  @ValidateIf(hasAnyDestinationField)
  @IsCap()
  destinationCap?: string | null;

  @ValidateIf(hasAnyDestinationField)
  @IsString()
  @IsNotEmpty()
  destinationCitta?: string | null;

  @ValidateIf(hasAnyDestinationField)
  @OptionalStringTransform()
  @Transform(uppercase)
  @Matches(PROVINCIA_REGEX, { message: 'Provincia non valida' })
  destinationProvincia?: string | null;

  @IsEmail()
  @IsOptional()
  @OptionalStringTransform()
  email?: string | null;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  phone?: string | null;
}
